<template>
  <a-loading :loading="bridgeMeta.loading">
    <bridge-form
      mode="edit"
      :bridge="bridge"
      @submit="handleSubmit"
      @delete="handleDelete"
    />
  </a-loading>
</template>

<script>
  import { BridgeForm } from '@/components'
  import { useBridge, useDeleteBridge, useEditBridge } from './bridgeHooks'
  import { ALoading } from 'codefabrik-gui-vue'

  export default {
    name: 'EditBridge',
    components: { BridgeForm, ALoading },
    mixins: [
      useBridge('bridge'),
      useEditBridge('handleSubmit'),
      useDeleteBridge('handleDelete')
    ]
  }
</script>

<style scoped>

</style>
